import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ChakraProvider, Box, Container, Heading, Text, Button, VStack, Link } from '@chakra-ui/react';
import Navigation from './components/layout/Navigation';
import Home from './pages/Home';
import Register from './pages/Register';
import Cancel from './pages/Cancel';
import Activate from './pages/Activate';
import HowItWorks from './pages/HowItWorks';
import FAQ from './pages/FAQ';
import PasswordReset from './pages/PasswordReset';
import RegistrySuccess from './pages/RegistrySuccess';
import RegistryView from './pages/RegistryView';
import TechStack from './pages/TechStack';
import theme from './theme'; // Import our custom theme
import FindAFriend from './pages/FindAFriend';
import Login from './pages/Login';
import SignUpSuccess from './pages/SignUpSuccess';
import Support from './pages/Support';
import CompanyAccess from './pages/CompanyAccess';
import './App.css';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <div className="App">
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/tech-stack" element={<TechStack />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/registry-success/:registryId" element={<RegistrySuccess />} />
            <Route path="/registry/:registryId" element={<RegistryView />} />
            <Route path="/registry/:registryId/cancel/:gifterId" element={<Cancel />} />
            <Route path="/registry/:registryId/activate/:activationId" element={<Activate />} />
            <Route path="/registry/:registryId/resetPW/:token" element={<PasswordReset />} />
            <Route path="/find-a-friend" element={<FindAFriend />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registry/:registryId/signup-success" element={<SignUpSuccess />} />
            <Route path="/support" element={<Support />} />
            <Route path="/company-access" element={<CompanyAccess />} />
          </Routes>
        </div>
      </Router>
    </ChakraProvider>
  );
}

export default App;
